import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import DropdownSelect from 'Shared/UI/DropdownSelect';
import { StyledField } from 'Components/AccountSettings/helpers';
import ConfirmDialog from 'Shared/ConfirmDialog';

const FONT = "'Open Sans', sans-serif";

const ValidateCartModal = ({
  open, onClose, onConfirm, expeditions, loading, error,
}) => {
  const [expedition, setExpedition] = useState(null);
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (!open) {
      setExpedition(null);
      setComment('');
    }
  }, [open]);

  const handleConfirm = () => {
    if (!expedition) return;
    onConfirm(expedition, comment);
  };

  return (
    <ConfirmDialog
      open={open}
      variant="validate"
      title="Valider ce panier"
      message="Choisir le mode de transport avant de valider."
      confirmLabel="Valider le panier"
      confirmDisabled={!expedition || !!error}
      loading={loading}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Box sx={{ mb: '12px' }}>
        <DropdownSelect
          options={(expeditions || []).map((e) => ({ value: String(e.id), label: e.name }))}
          value={expedition ? String(expedition.id) : ''}
          onChange={(val) => {
            const exp = (expeditions || []).find((e) => String(e.id) === val);
            setExpedition(exp || null);
          }}
          placeholder="Transport"
          fontSize="14px"
          width="100%"
        />
      </Box>
      <StyledField
        label="Commentaire:"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        multiline
        rows={3}
        inputProps={{ style: { paddingTop: '8px' } }}
      />
      {error && (
        <Box
          sx={{
            mt: '14px',
            backgroundColor: '#FFFBF0',
            border: '1px solid #F0C060',
            borderRadius: '8px',
            px: '14px',
            py: '10px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
          }}
        >
          <WarningAmberRoundedIcon
            sx={{
              fontSize: 18,
              color: '#D4900A',
              mt: '1px',
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              fontSize: '13px',
              color: '#9A6200',
              fontFamily: FONT,
              fontWeight: 600,
              lineHeight: 1.5,
            }}
          >
            {error}
          </Typography>
        </Box>
      )}
    </ConfirmDialog>
  );
};

export default ValidateCartModal;
